// Maps fetched IQE project runs API response for a single project to domain model

import type { TestRun } from '../../interfaces/ui';
import type { IqeProjectRunsApiResponse } from '../../interfaces/api/responses/getIqeProjectRuns.response';
import { toTestRuns } from '../sharedDto/status.dto';
import { sortRunsByDateDescending } from '../../utils';

export function toIqeProjectRunsDomain(
  response: IqeProjectRunsApiResponse,
): TestRun[] {
  if (!response) {
    return [];
  }

  const runs = response?.data?.runs || [];
  return sortRunsByDateDescending(runs.map(toTestRuns));
}
